import { useContext, useEffect } from 'react'
import styled from 'styled-components'
import { ThemeContext } from '../../contexts/ThemeContext'

const FloatingNavContainer = styled.div`
	position: fixed;
	bottom: 20px;
	margin: 0 auto;

	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 8px 40px;

	height: 56px;
	background: var(--background-color);
	box-shadow: -4px 8px 48px rgba(0, 0, 0, 0.1), 8px 0px 100px rgba(0, 0, 0, 0.02);
	border-radius: 64px;
	transition: all 0.4s ease-in-out;

	z-index: 100;

	& > div {
		display: flex;
		flex-direction: column;
		align-items: center;

		& > svg {
			margin-bottom: 4px;
		}

		& > p {
			font-family: 'Apercu';
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			line-height: 22px;
			text-align: center;
			color: var(--primary-manual-text-color);
		}
	}

	& > span {
		height: 36px;
		border: 1px solid var(--border-color);
		margin: 0 28px;
	}
`

const StyledSVG = styled.svg`
	path {
		stroke: var(--svg-stroke-color);
	}
`

interface IFloatingNavStyleProps {
	isShown: boolean
}

const FloatingNav = ({ isShown }: IFloatingNavStyleProps) => {
	const { theme, toggleTheme } = useContext(ThemeContext)

	useEffect(() => {
		const floatingManualNav = document.querySelector('.floating-nav') as HTMLDivElement | null

		if (floatingManualNav != null) {
			if (isShown) {
				floatingManualNav.style.bottom = '20px'
			} else {
				floatingManualNav.style.bottom = '-100px'
			}
		}
	}, [isShown])

	return (
		<FloatingNavContainer className='floating-nav'>
			<div onClick={toggleTheme} style={{ cursor: 'pointer' }}>
				<StyledSVG width='20' height='20' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
					<path
						d='M23.7016 16.6906C21.9837 17.1724 20.1685 17.1881 18.4424 16.7364C16.7164 16.2846 15.1417 15.3815 13.8801 14.1199C12.6185 12.8583 11.7154 11.2836 11.2636 9.55757C10.8119 7.83154 10.8277 6.01635 11.3094 4.29843C9.61567 4.76985 8.07503 5.6768 6.84092 6.92894C5.6068 8.18107 4.72228 9.7347 4.27547 11.4351C3.82865 13.1354 3.83513 14.9232 4.29426 16.6203C4.75339 18.3174 5.64915 19.8645 6.89231 21.1077C8.13547 22.3509 9.68264 23.2466 11.3797 23.7057C13.0768 24.1649 14.8646 24.1714 16.5649 23.7245C18.2653 23.2777 19.8189 22.3932 21.0711 21.1591C22.3232 19.925 23.2302 18.3843 23.7016 16.6906V16.6906Z'
						strokeWidth='1.5'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
				</StyledSVG>
				<p>{theme === 'light' ? 'Dark Mode' : 'Light Mode'}</p>
			</div>

			{/* <span></span>

			<div>
				<StyledSVG width='20' height='20' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
					<path
						d='M3.5 23.625V6.125C3.5 5.89294 3.59219 5.67038 3.75628 5.50628C3.92038 5.34219 4.14294 5.25 4.375 5.25H23.625C23.8571 5.25 24.0796 5.34219 24.2437 5.50628C24.4078 5.67038 24.5 5.89294 24.5 6.125V23.625L21 21.875L17.5 23.625L14 21.875L10.5 23.625L7 21.875L3.5 23.625Z'
						strokeWidth='1.5'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
					<path d='M15.75 12.25H21' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
					<path d='M15.75 15.75H21' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
					<path
						d='M12.25 10.5H7V17.5H12.25V10.5Z'
						strokeWidth='1.5'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
				</StyledSVG>
				<p>Hard Copy</p>
			</div> */}
		</FloatingNavContainer>
	)
}

export default FloatingNav
